module.exports = __webpack_public_path__ + "static/media/logo_donmanuel.e64089f1.png";